// src/kpi/index.js
// Kpi — extracted from index.html (v105.x sprint, auto-generated header).
// Bundled by esbuild into dist/kpi.js. The HTML loads it via
//   <script src="dist/kpi.js"></script>
// and call sites use `Kpi.<sub>.<fn>()` (e.g.
//   Kpi.screen.renderKpiScreen()
//   Kpi.tabs.switchKpiTab()
//   Kpi.controls.toggleKpiTargetMode()
//   Kpi.aggregate.switchAggregateScope()
//   Kpi.period.renderKpiPeriodView()
//   Kpi.day.renderKpiDayView()
//   Kpi.compare.renderKpiCompareView()
//   Kpi.demo.renderDemoLineCard()
// ).
//
// Backwards compat: index.html's trailing script block re-exposes the
// moved functions on window so existing call sites — both inline JS and
// onclick="" attributes — keep working without HTML edits.
//
// Free variables (DB, currentUser, currentStore, escapeHtml, WORKER_URL,
// fetch, console, document, window, ...) live in the inline globals
// scope of index.html. esbuild leaves them as bare references at runtime.

// ── screen ─────────────────────────────────────────────
export const screen = {};

function renderKpiScreen(){
  // Set up store selector for multi-store users (area managers, admins).
  // Single-store users see their store's KPIs without a picker.
  var sel = document.getElementById('kpiStoreSelect');
  var isMultiStore = currentUser && (currentUser.role === 'area_manager' || currentUser.role === 'admin');

  if (isMultiStore && sel) {
    // Use the existing getMyStores() helper — same logic the rest of the
    // app uses for area filtering. Returns an array of store name strings,
    // already deduped and sorted, scoped to the user's area for area_managers
    // or all stores for admins.
    var stores = (typeof getMyStores === 'function') ? getMyStores() : [];

    // Populate select. Default to currentStore if it's in the list, else first store.
    sel.innerHTML = '';
    stores.forEach(function(name){
      var opt = document.createElement('option');
      opt.value = name; opt.textContent = name;
      sel.appendChild(opt);
    });
    var defaultStore = (currentStore && stores.indexOf(currentStore) !== -1) ? currentStore : stores[0];
    if (defaultStore) sel.value = defaultStore;
    sel.style.display = 'block';
    _kpiCurrentStore = sel.value || currentStore;
  } else {
    // Single-store user: hide the dropdown, lock to their store
    if (sel) sel.style.display = 'none';
    _kpiCurrentStore = currentStore;
  }

  if (!_kpiCurrentStore) {
    document.getElementById('kpiContent').innerHTML = '<div style="font-size:13px;color:var(--sub);text-align:center;padding:40px 14px">No store selected.</div>';
    return;
  }

  loadKpiData(_kpiCurrentStore);
  renderHighlights(_kpiCurrentStore);   // v129.47 — its own container, own fetch
}
screen.renderKpiScreen = renderKpiScreen;

// ── 📈 Highlights (v129.47 — social layer #4, the anti-leaderboard) ─────────
// Most-improved ranks by week-over-week DELTA (the middle of the pack can win
// it); personal bests compare the store to ITSELF. No ranked list is ever
// rendered — top 3 only, the podium rule. Fails to NOTHING: a card with no
// data renders empty, never an error over the KPI screen.
async function renderHighlights(store) {
  var box = document.getElementById('kpiHighlights');
  if (!box) return;
  box.innerHTML = '';
  if (!store) return;
  try {
    var base = (typeof DB !== 'undefined' && DB.workerUrl) ? DB.workerUrl() : '';
    var tk = (typeof DB !== 'undefined' && DB.getToken) ? DB.getToken() : null;
    var headers = { 'Content-Type': 'application/json' };
    if (tk) headers['Authorization'] = 'Bearer ' + tk;
    var res = await fetch(base + '/api/kpi/highlights?store=' + encodeURIComponent(store), { headers: headers, cache: 'no-store' });
    if (!res.ok) return;
    var d = await res.json();
    if (!d || !d.ok) return;
    var bits = [];
    if (d.mine && d.mine.last_week_is_best) {
      bits.push('<div style="font-weight:800;font-size:13px">🏅 Last week was your best week in the last 10 — ' +
        Number(d.mine.best_week_total).toLocaleString() + ' AED. Your own record, beaten.</div>');
    } else if (d.mine && d.mine.best_week_total) {
      bits.push('<div style="font-size:12.5px;color:var(--sub,#5e6863)">🎯 Your best week in the last 10: <b>' +
        Number(d.mine.best_week_total).toLocaleString() + ' AED</b>' +
        (d.mine.best_day ? ' · best day: ' + Number(d.mine.best_day.sales).toLocaleString() + ' AED' : '') +
        ' — that is the one to beat.</div>');
    }
    if (Array.isArray(d.most_improved) && d.most_improved.length) {
      var medals = ['🥇', '🥈', '🥉'];
      bits.push('<div style="font-size:12.5px;margin-top:6px"><b>📈 Most improved last week</b> (vs their own previous week): ' +
        d.most_improved.map(function (r, i) {
          return medals[i] + ' ' + escapeHtml(r.store) + ' +' + r.pct + '%';
        }).join(' · ') + '</div>');
    }
    if (!bits.length) return;
    box.innerHTML = '<div style="background:var(--stores-ok-soft);border:1px solid var(--stores-ok-line);border-radius:12px;padding:11px 13px;margin-bottom:10px">' +
      bits.join('') + '</div>';
  } catch (e) { /* highlights are garnish — never an error over KPIs */ }
}
screen.renderHighlights = renderHighlights;

function renderKpiFilterBar() {
  var label = _kpiShowFuture ? 'Showing full year.' : 'Showing past dates only.';
  var action = _kpiShowFuture ? 'Show past only' : 'Show full year';

  // v86.10: WTD ↔ Full-period toggle. Only meaningful for Week / Month
  // views (Day view is daily, no run-rate concept). Hidden on other tabs.
  var targetToggleHtml = '';
  if (_kpiActiveTab === 'week' || _kpiActiveTab === 'month') {
    var periodWord = _kpiActiveTab === 'week' ? 'week' : 'month';
    var targetLabel  = _kpiTargetMode === 'wtd'
      ? 'Target: ' + (periodWord === 'week' ? 'WTD' : 'MTD')
      : 'Target: full ' + periodWord;
    var targetAction = _kpiTargetMode === 'wtd'
      ? 'Switch to full ' + periodWord
      : 'Switch to ' + (periodWord === 'week' ? 'WTD' : 'MTD');
    targetToggleHtml =
      '<span style="margin-inline-end:10px">' + escapeHtml(targetLabel) + ' ' +
      '<button onclick="toggleKpiTargetMode()" style="background:none;border:none;color:var(--rota-green-ink);font-size:11px;cursor:pointer;padding:2px 4px;font-weight:600;font-family:inherit">' +
        escapeHtml(targetAction) +
      '</button></span>';
  }

  return '<div style="text-align:end;font-size:11px;color:var(--sub);padding:6px 4px 0">' +
    targetToggleHtml +
    escapeHtml(label) + ' ' +
    '<button onclick="toggleKpiFuture()" style="background:none;border:none;color:var(--rota-green-ink);font-size:11px;cursor:pointer;padding:2px 4px;font-weight:600;font-family:inherit">' +
      escapeHtml(action) +
    '</button>' +
  '</div>';
}
screen.renderKpiFilterBar = renderKpiFilterBar;

// ── tabs ─────────────────────────────────────────────
export const tabs = {};

function switchKpiTab(tab){ renderKpiTab(tab); }
tabs.switchKpiTab = switchKpiTab;

function renderKpiTab(tab){
  _kpiActiveTab = tab;

  // v79.13: six tabs now — Overview (the headline cards + bonus tracker +
  // demo line, was previously always-visible), Day/Week/Month/Compare
  // (the per-period table views), and AI Insights (was previously a card
  // permanently above the tabs). Three content wrappers in the DOM —
  // we show one and hide the other two depending on the active tab.
  // v80.6: aiinsights tab removed — its card now lives inside Overview.
  // v126.15 (Matt: "kpi count should be its own tab — it overpowers the sales
  // overview"): 'addons' (the 🎯 tap counter) + 'badges' (the 🏆 shelf) join.
  var allTabs = ['overview','addons','badges','day','week','month','compare','top50'];
  allTabs.forEach(function(t){
    // Tab IDs use camelCase; e.g. 'top50' → 'kpiTabTop50'
    var btnId = 'kpiTab' + (
      t === 'top50' ? 'Top50'
      : t.charAt(0).toUpperCase() + t.slice(1)
    );
    var btn = document.getElementById(btnId);
    if (!btn) return;
    // v86.3 — class-toggle replaces three style mutations per button.
    // CSS rules .kpi-tab and .kpi-tab.is-active handle visual state.
    if (t === tab) {
      btn.classList.add('is-active');
    } else {
      btn.classList.remove('is-active');
    }
  });

  // Toggle the three content wrappers. Only one is visible at a time.
  // v80.6: aiinsights wrapper gone — its card is rendered inside Overview.
  // v84.0: tradedrives wrapper added — the comparison playground.
  var ovWrap = document.getElementById('kpiTabContentOverview');
  var tbWrap = document.getElementById('kpiTabContentTable');
  var t50Wrap = document.getElementById('kpiTabContentTop50');
  var tdWrap = document.getElementById('kpiTabContentTradeDrives');
  var adWrap = document.getElementById('kpiTabContentAddons');
  var bdWrap = document.getElementById('kpiTabContentBadges');
  if (ovWrap)  ovWrap.style.display   = (tab === 'overview')    ? '' : 'none';
  if (t50Wrap) t50Wrap.style.display  = (tab === 'top50')       ? '' : 'none';
  if (tdWrap)  tdWrap.style.display   = (tab === 'tradedrives') ? '' : 'none';
  if (adWrap)  adWrap.style.display   = (tab === 'addons')      ? '' : 'none';
  if (bdWrap)  bdWrap.style.display   = (tab === 'badges')      ? '' : 'none';
  if (tbWrap)  tbWrap.style.display   = (tab === 'day' || tab === 'week' || tab === 'month' || tab === 'compare') ? '' : 'none';

  // v126.15: the moved-in tabs render fresh on entry (guarded — cross-bundle).
  if (tab === 'addons' && typeof AddonTally !== 'undefined' && AddonTally.render) AddonTally.render();
  if (tab === 'badges' && typeof Achievements !== 'undefined' && Achievements.renderShelf) Achievements.renderShelf();

  // Render the table-view active tab. Overview needs no re-render — its
  // cards (KPI + bonus tracker + demo line + AI insights) are populated
  // separately. The AI Insights card renders on-demand when the user
  // clicks Generate.
  if (tab === 'day')         renderKpiDayView(_kpiData || []);
  if (tab === 'week')        renderKpiWeekView(_kpiData || []);
  if (tab === 'month')       renderKpiMonthView(_kpiData || []);
  if (tab === 'compare')     renderKpiCompareView();
  if (tab === 'top50')       Top50.staff.onTabOpen();
  if (tab === 'tradedrives') TradeDrives.onTabOpen();
}
tabs.renderKpiTab = renderKpiTab;

function renderKpiCards(rows){
  var todayStr = localDateStr(new Date());

  // Find today's target. If no row matches today, leave blank.
  var todayRow = rows.find(function(r){ return r.date === todayStr; });
  var todayTarget = todayRow && todayRow.target != null ? Number(todayRow.target) : null;

  // YTD aggregates — only COMPLETED days (strictly before today).
  // v81.2: Was `<= todayStr` which included today. Today's sales row
  // may have sales=0 (uploaded but not yet earned) alongside its full
  // target value, which dragged the comparison ratio down unfairly.
  // Today's standalone "Today's target" card uses a separate lookup
  // on line above and is unaffected by this filter.
  // Sales row is excluded if sales is null (not yet uploaded).
  var pastRows = rows.filter(function(r){ return r.date < todayStr; });
  var sumSales  = 0, sumTarget = 0, sumLY = 0;
  var hasSales  = 0, hasTarget = 0, hasLY = 0;
  pastRows.forEach(function(r){
    if (r.sales != null)     { sumSales  += Number(r.sales);  hasSales++; }
    if (r.target != null)    { sumTarget += Number(r.target); hasTarget++; }
    if (r.last_year != null) { sumLY     += Number(r.last_year); hasLY++; }
  });

  // YTD vs target — compare cumulative sales to cumulative target on dates
  // where BOTH exist. Comparing different denominators would mislead.
  var sumSalesForTargetCmp = 0, sumTargetForCmp = 0;
  pastRows.forEach(function(r){
    if (r.sales != null && r.target != null) {
      sumSalesForTargetCmp += Number(r.sales);
      sumTargetForCmp      += Number(r.target);
    }
  });

  // YTD vs last year — same pattern
  var sumSalesForLyCmp = 0, sumLyForCmp = 0;
  pastRows.forEach(function(r){
    if (r.sales != null && r.last_year != null) {
      sumSalesForLyCmp += Number(r.sales);
      sumLyForCmp      += Number(r.last_year);
    }
  });

  // Today's target card
  var todayValEl = document.getElementById('kpiTodayValue');
  var todaySubEl = document.getElementById('kpiTodaySub');
  if (todayTarget != null) {
    todayValEl.textContent = formatCurrency(todayTarget);
    todaySubEl.textContent = todayStr;
  } else {
    todayValEl.textContent = '—';
    todaySubEl.textContent = 'no target set';
  }

  // YTD vs target card
  var vtVal = document.getElementById('kpiVsTargetValue');
  var vtSub = document.getElementById('kpiVsTargetSub');
  if (sumTargetForCmp > 0) {
    var pctTarget = (sumSalesForTargetCmp - sumTargetForCmp) / sumTargetForCmp;
    vtVal.textContent = formatPct(pctTarget);
    vtVal.style.color = pctTarget >= 0 ? 'var(--ok)' : 'var(--danger-deep)';
    vtSub.textContent = formatCurrency(sumSalesForTargetCmp) + ' / ' + formatCurrency(sumTargetForCmp);
  } else {
    vtVal.textContent = '—';
    vtVal.style.color = '';
    vtSub.textContent = hasTarget === 0 ? 'no targets uploaded' : 'no sales uploaded';
  }

  // YTD vs last year card
  var lyVal = document.getElementById('kpiVsLyValue');
  var lySub = document.getElementById('kpiVsLySub');
  if (sumLyForCmp > 0) {
    var pctLy = (sumSalesForLyCmp - sumLyForCmp) / sumLyForCmp;
    lyVal.textContent = formatPct(pctLy);
    lyVal.style.color = pctLy >= 0 ? 'var(--ok)' : 'var(--danger-deep)';
    lySub.textContent = formatCurrency(sumSalesForLyCmp) + ' / ' + formatCurrency(sumLyForCmp);
  } else {
    lyVal.textContent = '—';
    lyVal.style.color = '';
    lySub.textContent = hasLY === 0 ? 'no last-year data' : 'no sales uploaded';
  }
}
tabs.renderKpiCards = renderKpiCards;

// ── controls ─────────────────────────────────────────────
export const controls = {};

function toggleKpiTargetMode(){
  _kpiTargetMode = _kpiTargetMode === 'wtd' ? 'fullperiod' : 'wtd';
  renderKpiTab(_kpiActiveTab);
}
controls.toggleKpiTargetMode = toggleKpiTargetMode;

function toggleKpiFuture() {
  _kpiShowFuture = !_kpiShowFuture;
  // v130.48 — the fetch is now clipped to the end of the CURRENT MONTH (the
  // rest of the year was 50 KB the renderer threw away). So turning "show full
  // year" ON has to fetch the remainder before it can draw it, or the chart
  // would simply stop at month end and look like missing data.
  //
  // Turning it OFF never re-fetches: the wider data is already in hand and the
  // renderer filters it. Paying for a request to show LESS would be silly.
  var through = (typeof window !== "undefined" && window._kpiLoadedThrough) || "";
  var clipped = through && through.slice(5) !== "12-31";
  if (_kpiShowFuture && clipped && typeof loadKpiData === "function") {
    loadKpiData(typeof _kpiCurrentStore !== "undefined" ? _kpiCurrentStore : null);
    return;
  }
  renderKpiTab(_kpiActiveTab);
}
controls.toggleKpiFuture = toggleKpiFuture;

function toggleKpiNoteEditor(dateStr) {
  // Toggle: if this date is already the active editor, close it. Otherwise open it.
  if (_kpiNoteEditingDate === dateStr) {
    _kpiNoteEditingDate = null;
  } else {
    _kpiNoteEditingDate = dateStr;
  }
  renderKpiTab(_kpiActiveTab);
  // Auto-focus the textarea after re-render
  if (_kpiNoteEditingDate) {
    setTimeout(function(){
      var ta = document.getElementById('kpiNoteInput_' + _kpiNoteEditingDate);
      if (ta) ta.focus();
    }, 50);
  }
}
controls.toggleKpiNoteEditor = toggleKpiNoteEditor;

// ── aggregate ─────────────────────────────────────────────
export const aggregate = {};

function switchAggregateScope(scope){
  _kpiAggregateScope = scope;
  var tabs = document.querySelectorAll('#kpiAggregateScopeTabs .kpi-agg-tab');
  // v86.5 — class-toggle replaces three style mutations per button.
  tabs.forEach(function(t){
    var active = t.getAttribute('data-scope') === scope;
    if (active) {
      t.classList.add('is-active');
    } else {
      t.classList.remove('is-active');
    }
  });
  // Keep the month dropdown in sync: a tab (MTD/QTD/YTD) click clears it; picking a
  // month leaves it showing that month (and the tabs above all de-activate).
  var msel = document.getElementById('kpiAggregateMonthSelect');
  if (msel) msel.value = (scope === 'MTD' || scope === 'QTD' || scope === 'YTD') ? '' : scope;
  if (_kpiCurrentStore) loadAggregateKpi(_kpiCurrentStore);
}
aggregate.switchAggregateScope = switchAggregateScope;

function renderAggregateKpi(data){
  var body = document.getElementById('kpiAggregateBody');
  if (!body) return;
  if (!data) {
    body.innerHTML = '<div style="font-size:11px;color:var(--sub);text-align:center;padding:14px">No data</div>';
    return;
  }
  var rowHtml = function(label, sub, sales, target) {
    var pct = (target > 0) ? (sales / target) : null;
    var pctStr = pct != null ? formatPct(pct - 1) : '—';
    var pctColor = pct == null ? 'var(--sub)'
                  : pct >= 1 ? 'var(--elc-green)'
                  : pct >= 0.95 ? 'var(--elc-pos-preorder)'
                  : 'var(--elc-pos-coming)';
    return '<div style="display:flex;align-items:center;justify-content:space-between;padding:8px 12px;border-bottom:1px solid var(--surface-3)">' +
      '<div style="min-width:0;flex:1">' +
        '<div style="font-size:12px;font-weight:600">' + escapeHtml(label) + '</div>' +
        (sub ? '<div style="font-size:10px;color:var(--sub)">' + escapeHtml(sub) + '</div>' : '') +
      '</div>' +
      '<div style="text-align:end;font-variant-numeric:tabular-nums;flex:0 0 auto">' +
        '<div style="font-size:12px;font-weight:600">' + (sales != null ? formatCurrencyShort(sales) : '—') +
          ' <span style="color:var(--sub);font-weight:400">/ ' + (target != null ? formatCurrencyShort(target) : '—') + '</span></div>' +
        '<div style="font-size:11px;font-weight:700;color:' + pctColor + '">' + pctStr + '</div>' +
      '</div>' +
    '</div>';
  };
  var html = '';
  // Your store
  html += rowHtml(
    'Your store',
    data.store && data.store.name ? data.store.name : null,
    data.store ? data.store.sales : null,
    data.store ? data.store.target : null
  );
  // Your area — v131.77 (an area manager: "To see area 2 sales and add
  // ons performance ... I can only see Store past month, UAE and company").
  // The area sits between the store and the country because that is where it
  // sits in the business: it is the number an AM is accountable for, and it was
  // the one scope missing. Omitted entirely when the store has no area, rather
  // than rendered as an empty row.
  if (data.area && data.area.name) {
    html += rowHtml(
      data.area.name,
      data.area.store_count ? data.area.store_count + ' stores' : null,
      data.area.sales,
      data.area.target
    );
  }
  // Country
  html += rowHtml(
    data.country && data.country.name ? data.country.name : 'Country',
    data.country && data.country.store_count ? data.country.store_count + ' stores' : null,
    data.country ? data.country.sales : null,
    data.country ? data.country.target : null
  );
  // Company
  html += rowHtml(
    'Company',
    data.company && data.company.store_count ? data.company.store_count + ' stores' : null,
    data.company ? data.company.sales : null,
    data.company ? data.company.target : null
  );
  body.innerHTML = html;
  // Strip the trailing border on the last row
  var rows = body.querySelectorAll('div[style*="border-bottom"]');
  if (rows.length) rows[rows.length - 1].style.borderBottom = 'none';
}
aggregate.renderAggregateKpi = renderAggregateKpi;

function renderKpiAiSummaryCard() {
  // Re-render the summary card from current state. Called on KPI screen open
  // and after each generate.
  var meta   = document.getElementById('kpiAiSummaryMeta');
  var btn    = document.getElementById('kpiAiSummaryBtn');
  var result = document.getElementById('kpiAiSummaryResult');
  var scope  = document.getElementById('kpiAiSummaryScope');
  if (!meta || !btn || !result || !scope) return;

  if (_kpiAiSummaryLoading) {
    meta.textContent = 'Asking Claude\u2026';
    btn.disabled = true;
    btn.textContent = '\u2026';
    btn.style.opacity = '0.6';
    result.style.display = 'none';
    return;
  }
  btn.disabled = false;
  btn.style.opacity = '1';

  if (_kpiAiSummary && _kpiAiSummary.text) {
    meta.innerHTML = 'Generated ' + escapeHtml(formatRelativeTime(_kpiAiSummary.generated_at)) +
                     ' \u2022 ' + escapeHtml(_kpiAiSummary.scope) +
                     ' (' + escapeHtml(_kpiAiSummary.from) + ' to ' + escapeHtml(_kpiAiSummary.to) + ')';
    btn.textContent = 'Regenerate';
    result.style.display = 'block';
    result.textContent = _kpiAiSummary.text;
    if (scope.value !== _kpiAiSummary.scope) scope.value = _kpiAiSummary.scope;
  } else {
    meta.textContent = 'Get an area-manager-style summary of your store\u2019s performance';
    btn.textContent = 'Generate';
    result.style.display = 'none';
  }
}
aggregate.renderKpiAiSummaryCard = renderKpiAiSummaryCard;

// ── period ─────────────────────────────────────────────
export const period = {};

function renderKpiPeriodView(rows, keyFn, periodLabel, currentPeriodKey){
  var content = document.getElementById('kpiContent');

  // Filter to past+today (default) before aggregation, so future weeks/months
  // don't pollute the table. Aggregation correctly handles partial-current
  // periods via the salesForTargetCmp / targetForCmp pairs already.
  var todayStr = localDateStr(new Date());
  var filteredRows = _kpiShowFuture ? rows : rows.filter(function(r){ return r.date <= todayStr; });
  var groups = aggregateRows(filteredRows, keyFn);

  if (!groups.length) {
    content.innerHTML = renderKpiFilterBar() +
      '<div style="background:var(--card);border:1px solid var(--brand-hairline);border-radius:var(--brand-r-card);padding:30px 18px;text-align:center;margin-top:8px;box-shadow:0 1px 3px rgba(0,0,0,0.03)">' +
      '<div style="font-size:30px;margin-bottom:8px">📊</div>' +
      '<div style="font-size:14px;font-weight:800;margin-bottom:4px;font-family:var(--brand-font);color:var(--text)">No data yet</div>' +
      '<div style="font-size:12px;color:var(--tiny);line-height:1.5;font-family:var(--brand-font-text)">' +
      'Once your admin uploads the master spreadsheet, ' + periodLabel.toLowerCase() + ' totals will appear here.' +
      '</div></div>';
    return;
  }

  // Reverse so most-recent period is at the top.
  var sorted = groups.slice().reverse();

  // Period addon cell — same color coding as Day view's addonCell, but
  // 0/0 is treated as "no data" rather than "underperformed" (period
  // sums of nulls collapse to 0; we shouldn't flag those as red).
  function periodAddonCell(actual, target) {
    if (actual === 0 && target === 0) return { text: '—', color: 'var(--sub)' };
    if (target === 0) return { text: actual + '/—', color: 'var(--sub)' };
    if (actual === 0) return { text: '\u2013/' + target, color: 'var(--sub)' };
    // v86.6 — ELC brand palette replaces traffic-light HEX.
    var color = actual >= target ? 'var(--elc-green)' : (actual >= target * 0.8 ? 'var(--elc-pos-preorder)' : 'var(--elc-pos-coming)');
    return { text: actual + '/' + target, color: color };
  }

  var html = renderKpiFilterBar();
  html += '<div style="max-width:980px;margin:4px auto 0;background:var(--card);border:1px solid var(--brand-hairline);border-radius:var(--brand-r-card);position:relative;box-shadow:0 1px 3px rgba(0,0,0,0.03)">';
  html += '<table style="width:100%;min-width:780px;font-size:12px;border-collapse:collapse">';

  // v86.6 — header uses brand soft-green surface + Nunito.
  var thBase = 'background:var(--elc-green-soft);border-bottom:1px solid var(--brand-hairline);font-weight:800;position:sticky;top:var(--top-h,56px);z-index:20;font-family:var(--brand-font);color:var(--elc-green);text-transform:uppercase;letter-spacing:0.04em;font-size:11px';
  html += '<thead><tr>' +
    '<th style="text-align:start;padding:10px;'  + thBase + '">' + periodLabel + '</th>' +
    '<th style="text-align:end;padding:10px 6px;' + thBase + '">Sales</th>' +
    '<th style="text-align:end;padding:10px 6px;' + thBase + '">Target</th>' +
    '<th style="text-align:end;padding:10px 6px;' + thBase + '">vs Target</th>' +
    '<th style="text-align:end;padding:10px 6px;' + thBase + '">vs LY</th>' +
    '<th style="text-align:end;padding:10px 6px;' + thBase + '">Demo</th>' +
    '<th style="text-align:end;padding:10px 6px;' + thBase + '">Bat</th>' +
    '<th style="text-align:end;padding:10px 6px;' + thBase + '">Wrap</th>' +
    '<th style="text-align:end;padding:10px 6px;' + thBase + '">Bag</th>' +
    '<th style="text-align:end;padding:10px 6px;' + thBase + '">Cards</th>' +
    '</tr></thead><tbody>';

  sorted.forEach(function(p){
    var isCurrent = p.sortKey === currentPeriodKey;
    // v86.6 — current-period highlight uses brand soft-yellow instead of #fef9c3.
    var rowBg = isCurrent ? 'background:var(--stores-amber-soft)' : '';

    // v80.16 — extend "Pending upload" to period views.
    var salesCell;
    if (p.hasSales) {
      salesCell = formatCurrencyShort(p.sales);
    } else if (!_kpiShowFuture) {
      // v86.6 — pending-upload italic uses brand preorder orange.
      salesCell = '<span style="color:var(--elc-pos-preorder);font-style:italic;font-size:11px;font-family:var(--brand-font-text);font-weight:600" title="Sales upload runs Mon\u2013Fri. Weekend sales typically appear Monday.">Pending upload</span>';
    } else {
      salesCell = '\u2014';
    }

    // Absolute period TARGET (the uploaded budget, summed to-date) — shown
    // independent of whether sales have arrived yet. Without this, a freshly
    // uploaded month/week with no sales shows nothing in Week/MTD even though
    // the target IS loaded (the Day tab shows it) — which read as "targets
    // weren't uploaded". (Head Office / June daily targets, 1 Jun 2026.)
    var targetCell = p.hasTarget ? formatCurrencyShort(p.target) : '—';

    // vs Target % — depends on _kpiTargetMode:
    //   wtd        → period-matched sums (only days where both sides exist)
    //   fullperiod → cumulative against the full period target (run rate)
    // For completed periods the two are equivalent (all days have sales);
    // only the CURRENT week/month behaves differently.
    var vtCell = '—', vtColor = '';
    var vtSales  = _kpiTargetMode === 'fullperiod' ? p.sales  : p.salesForTargetCmp;
    var vtTarget = _kpiTargetMode === 'fullperiod' ? p.target : p.targetForCmp;
    if (vtTarget > 0) {
      var pctTarget = (vtSales - vtTarget) / vtTarget;
      vtCell = formatPct(pctTarget);
      // v86.6 — brand palette.
      vtColor = pctTarget >= 0 ? 'var(--elc-green)' : 'var(--elc-pos-coming)';
    }

    // vs Last Year %
    var lyCell = '—', lyColor = '';
    if (p.lyForCmp > 0) {
      var pctLy = (p.salesForLyCmp - p.lyForCmp) / p.lyForCmp;
      lyCell = formatPct(pctLy);
      // v86.6 — brand palette.
      lyColor = pctLy >= 0 ? 'var(--elc-green)' : 'var(--elc-pos-coming)';
    }

    var demo  = periodAddonCell(p.demoActual,  p.demoTarget);
    var bat   = periodAddonCell(p.batActual,   p.batTarget);
    var wrap  = periodAddonCell(p.wrapActual,  p.wrapTarget);
    var bag   = periodAddonCell(p.bagActual,   p.bagTarget);
    var cards = periodAddonCell(p.cardsActual, p.cardsTarget);
    var addonStyle = 'text-align:end;padding:8px 6px;border-bottom:1px solid var(--surface-3);font-variant-numeric:tabular-nums;font-weight:700;font-size:11px;font-family:var(--brand-font)';

    html += '<tr style="' + rowBg + '">' +
      '<td style="padding:8px 10px;border-bottom:1px solid var(--surface-3)">' +
        '<div style="font-family:var(--brand-font-text);font-weight:' + (isCurrent ? '800' : '600') + '">' + escapeHtml(p.label) + '</div>' +
      '</td>' +
      '<td style="text-align:end;padding:8px 6px;border-bottom:1px solid var(--surface-3);font-variant-numeric:tabular-nums;font-family:var(--brand-font);font-weight:' + (p.hasSales ? '700' : '400') + '">' + salesCell + '</td>' +
      '<td style="text-align:end;padding:8px 6px;border-bottom:1px solid var(--surface-3);font-variant-numeric:tabular-nums;font-family:var(--brand-font);color:var(--sub);font-weight:' + (p.hasTarget ? '700' : '400') + '">' + targetCell + '</td>' +
      '<td style="text-align:end;padding:8px 6px;border-bottom:1px solid var(--surface-3);font-variant-numeric:tabular-nums;color:' + vtColor + ';font-weight:800;font-family:var(--brand-font)">' + vtCell + '</td>' +
      '<td style="text-align:end;padding:8px 6px;border-bottom:1px solid var(--surface-3);font-variant-numeric:tabular-nums;color:' + lyColor + ';font-weight:800;font-family:var(--brand-font)">' + lyCell + '</td>' +
      '<td style="' + addonStyle + ';color:' + demo.color  + '">' + demo.text  + '</td>' +
      '<td style="' + addonStyle + ';color:' + bat.color   + '">' + bat.text   + '</td>' +
      '<td style="' + addonStyle + ';color:' + wrap.color  + '">' + wrap.text  + '</td>' +
      '<td style="' + addonStyle + ';color:' + bag.color   + '">' + bag.text   + '</td>' +
      '<td style="' + addonStyle + ';color:' + cards.color + '">' + cards.text + '</td>' +
      '</tr>';
  });

  html += '</tbody></table></div>';
  content.innerHTML = html;
}
period.renderKpiPeriodView = renderKpiPeriodView;

function renderKpiWeekView(rows){
  var todayStr = localDateStr(new Date());
  var todayWeek = isoWeekFromDateStr(todayStr);
  var currentWeekKey = todayWeek.year + '-W' + String(todayWeek.week).padStart(2, '0');

  renderKpiPeriodView(
    rows,
    function(dateStr){
      var w = isoWeekFromDateStr(dateStr);
      // v79.10: include the week-commencing Monday in DD/MM/YYYY so users
      // can quickly map "Week 18" to a calendar date without counting.
      var monday = isoWeekMonday(w.year, w.week);
      return {
        sortKey: w.year + '-W' + String(w.week).padStart(2, '0'),
        label:   'Week ' + w.week + ' \u2014 ' + formatDDMMYYYY(monday),
        year:    w.year,
      };
    },
    'Week',
    currentWeekKey
  );
}
period.renderKpiWeekView = renderKpiWeekView;

function renderKpiMonthView(rows){
  var todayStr = localDateStr(new Date());
  var currentMonthKey = todayStr.slice(0, 7); // YYYY-MM

  renderKpiPeriodView(
    rows,
    function(dateStr){
      var m = monthLabelFromDateStr(dateStr);
      return {
        sortKey: m.sortKey,
        label:   m.label + ' ' + m.year,
        year:    m.year,
      };
    },
    'Month',
    currentMonthKey
  );
}
period.renderKpiMonthView = renderKpiMonthView;

function renderKpiPlaceholder(label){
  // Retained for compatibility — no longer called now that Week and Month
  // have real renderers, but keep in case future code paths reach here.
  var content = document.getElementById('kpiContent');
  content.innerHTML =
    '<div style="background:var(--card);border:1px solid var(--border);border-radius:12px;padding:30px 18px;text-align:center;margin-top:8px">' +
    '<div style="font-size:30px;margin-bottom:8px">⏳</div>' +
    '<div style="font-size:14px;font-weight:600;margin-bottom:4px">' + label + ' view coming soon</div>' +
    '</div>';
}
period.renderKpiPlaceholder = renderKpiPlaceholder;

// ── day ─────────────────────────────────────────────
export const day = {};

function renderKpiDayView(rows){
  var content = document.getElementById('kpiContent');

  // Filter: past+today (default), or all if user toggled "show full year".
  // Also drop empty rows (no sales/target/last_year) so we don't show
  // blank rows for future dates that have no target either.
  var todayStr = localDateStr(new Date());
  var rowsWithData = rows.filter(function(r){
    if (!_kpiShowFuture && r.date > todayStr) return false;
    return r.sales != null || r.target != null || r.last_year != null;
  });

  if (!rowsWithData.length) {
    content.innerHTML = renderKpiFilterBar() +
      '<div style="background:var(--card);border:1px solid var(--brand-hairline);border-radius:var(--brand-r-card);padding:30px 18px;text-align:center;margin-top:8px;box-shadow:0 1px 3px rgba(0,0,0,0.03)">' +
      '<div style="font-size:30px;margin-bottom:8px">📊</div>' +
      '<div style="font-size:14px;font-weight:800;margin-bottom:4px;font-family:var(--brand-font);color:var(--text)">No data yet</div>' +
      '<div style="font-size:12px;color:var(--tiny);line-height:1.5;font-family:var(--brand-font-text)">' +
      'Once your admin uploads the master spreadsheet, your sales numbers will appear here.' +
      '</div></div>';
    return;
  }

  // Sort descending — with the past-only default, today ends up at the top
  // of the table naturally, no scroll-into-view trick needed.
  var sorted = rowsWithData.slice().sort(function(a,b){ return b.date.localeCompare(a.date); });

  // v79.12: surface the run-rate banner if today's row (or the most-recent
  // row if today is missing) has a run_rate_pct set. Staff need to know
  // their addon targets are scaled — otherwise the lower numbers look
  // suspiciously easy.
  var todayRow = rows.find(function(r){ return r.date === todayStr; }) || sorted[0];
  var activeRunRate = todayRow && todayRow.run_rate_pct != null ? todayRow.run_rate_pct : null;
  var runRateBanner = '';
  if (activeRunRate != null) {
    runRateBanner =
      '<div style="max-width:980px;margin:6px auto 0;padding:10px 14px;background:var(--stores-amber-soft);border:1px solid var(--elc-pos-preorder);border-radius:var(--brand-r-inner);font-size:12px;color:var(--elc-pos-preorder);display:flex;align-items:center;gap:8px;font-family:var(--brand-font-text);font-weight:600">' +
      '<span style="font-size:14px">\u26A0\uFE0F</span>' +
      '<div>Add-on KPI targets currently scaled to <strong style="font-family:var(--brand-font);font-weight:800">' + activeRunRate + '%</strong> of normal. Sales targets are unchanged.</div>' +
      '</div>';
  }

  // Wider max-width on desktop because we now have 9 columns. On mobile the
  // table is unconstrained and horizontally scrolls at the wrapper level if
  // the cells get too tight.
  var html = renderKpiFilterBar() + runRateBanner;
  // v79.9 — sticky header fix.
  // Bug: today's row was rendering above the column header (visible in
  // Matt's screenshot). Root cause: the wrapper had `overflow-x:auto`,
  // which creates a scrolling container; CSS spec says any non-visible
  // overflow on one axis implies non-visible on the other for sticky's
  // containing block, so the thead was sticking to the wrapper instead
  // of the page. Fix: drop overflow on the wrapper. The table's
  // min-width:780px makes it overflow on narrow mobile viewports —
  // those become page-level horizontal scroll, which is acceptable
  // UX and lets sticky work correctly against page scroll.
  html += '<div style="max-width:980px;margin:4px auto 0;background:var(--card);border:1px solid var(--brand-hairline);border-radius:var(--brand-r-card);position:relative;box-shadow:0 1px 3px rgba(0,0,0,0.03)">';
  html += '<table style="width:100%;min-width:880px;font-size:12px;border-collapse:collapse;table-layout:fixed">';
  // v114.0 — a Head Office manager's layout: 12 columns. Date, Sales, Last Year (NEW),
  // vs Last Year %, Target, vs Target % (NEW), 5 addon categories, Notes.
  // Last-year value + vs-target % are derived from data already on each row.
  html +=   '<colgroup>' +
              '<col style="width:130px">' +   // Date
              '<col style="width:82px">' +    // Sales
              '<col style="width:84px">' +    // Last Year (NEW)
              '<col style="width:76px">' +    // vs Last Year %
              '<col style="width:80px">' +    // Target
              '<col style="width:76px">' +    // vs Target % (NEW)
              '<col style="width:54px">' +    // Demo
              '<col style="width:54px">' +    // Bat
              '<col style="width:54px">' +    // Wrap
              '<col style="width:54px">' +    // Bag
              '<col style="width:54px">' +    // Card
              '<col style="width:64px">' +    // Notes
            '</colgroup>';
  // top:var(--top-h,56px) keeps the header just below the sticky topbar (.topbar height, which grows by the iPhone safe-area inset since v133.51)
  // v86.6 — brand-fy: soft-green header surface, Nunito uppercase.
  var thBase = 'background:var(--elc-green-soft);border-bottom:1px solid var(--brand-hairline);font-weight:800;position:sticky;top:var(--top-h,56px);z-index:5;font-family:var(--brand-font);color:var(--elc-green);text-transform:uppercase;letter-spacing:0.04em;font-size:11px';
  html += '<thead><tr>' +
    '<th style="text-align:start;padding:10px;'  + thBase + '">Date</th>' +
    '<th style="text-align:end;padding:10px 6px;' + thBase + '">Sales</th>' +
    '<th style="text-align:end;padding:10px 6px;' + thBase + '">Last Year</th>' +
    '<th style="text-align:end;padding:10px 6px;' + thBase + '">vs Last Year %</th>' +
    '<th style="text-align:end;padding:10px 6px;' + thBase + '">Target</th>' +
    '<th style="text-align:end;padding:10px 6px;' + thBase + '">vs Target %</th>' +
    '<th style="text-align:end;padding:10px 6px;' + thBase + '" title="Demo units (actual/target)">Demo</th>' +
    '<th style="text-align:end;padding:10px 6px;' + thBase + '" title="Batteries (actual/target)">Bat</th>' +
    '<th style="text-align:end;padding:10px 6px;' + thBase + '" title="Gift Wrap (actual/target)">Wrap</th>' +
    '<th style="text-align:end;padding:10px 6px;' + thBase + '" title="Reusable Bag (actual/target)">Bag</th>' +
    '<th style="text-align:end;padding:10px 6px;' + thBase + '" title="Gift Cards (actual/target)">Card</th>' +
    '<th style="text-align:center;padding:10px;'     + thBase + '">Notes</th>' +
    '</tr></thead><tbody>';

  // Helper: format an addon cell as "actual/target" with color based on
  // whether actual met the target. "—/4" if no actual yet (today, future).
  // "—/—" if neither.
  function addonCell(actual, target) {
    if (actual == null && (target == null || target === 0)) {
      return { text: '—', color: 'var(--sub)' };
    }
    if (actual == null) {
      return { text: '–/' + target, color: 'var(--sub)' };
    }
    if (target == null || target === 0) {
      return { text: actual + '/—', color: 'var(--sub)' };
    }
    var color = actual >= target ? 'var(--elc-green)' : (actual >= target * 0.8 ? 'var(--elc-pos-preorder)' : 'var(--elc-pos-coming)');
    return { text: actual + '/' + target, color: color };
  }

  sorted.forEach(function(r){
    var isToday = r.date === todayStr;
    var isPast  = r.date <  todayStr;   // strict — today's blank stays as "—"
    // v86.6 — brand soft-yellow highlight.
    var rowBg = isToday ? 'background:var(--stores-amber-soft)' : '';
    var dateLabel = formatKpiDate(r.date);
    // v80.16 — "Pending upload" indicator.
    var salesCell;
    if (r.sales != null) {
      salesCell = formatCurrencyShort(r.sales);
    } else if (isPast) {
      salesCell = '<span style="color:var(--elc-pos-preorder);font-style:italic;font-size:11px;font-family:var(--brand-font-text);font-weight:600" title="Sales upload runs Mon\u2013Fri. Weekend sales typically appear Monday.">Pending upload</span>';
    } else {
      salesCell = '\u2014';
    }
    var targetCell = r.target != null ? formatCurrencyShort(r.target) : '\u2014';

    var lyCell = '—';
    var lyColor = '';
    if (r.sales != null && r.last_year != null && Number(r.last_year) > 0) {
      var pct = (Number(r.sales) - Number(r.last_year)) / Number(r.last_year);
      lyCell = formatPct(pct);
      // v86.6 — brand palette.
      lyColor = pct >= 0 ? 'var(--elc-green)' : 'var(--elc-pos-coming)';
    }

    // v114.0 — a Head Office manager's layout: raw Last Year value + Sales-vs-Target %.
    var lyValueCell = r.last_year != null ? formatCurrencyShort(r.last_year) : '\u2014';
    var vsTargetCell = '\u2014';
    var vsTargetColor = '';
    if (r.sales != null && r.target != null && Number(r.target) > 0) {
      var vtPct = (Number(r.sales) - Number(r.target)) / Number(r.target);
      vsTargetCell = formatPct(vtPct);
      vsTargetColor = vtPct >= 0 ? 'var(--elc-green)' : 'var(--elc-pos-coming)';
    }

    var demo = addonCell(r.actual_demo_units,   r.target_demo_units);
    var bat  = addonCell(r.actual_batteries,    r.target_batteries);
    var wrap = addonCell(r.actual_gift_wrap,    r.target_gift_wrap);
    var bag  = addonCell(r.actual_reusable_bag, r.target_reusable_bag);
    var card = addonCell(r.actual_gift_cards,   r.target_gift_cards);
    // v86.6 — Nunito on the numeric addon cells.
    var addonStyle = 'text-align:end;padding:8px 6px;border-bottom:1px solid var(--surface-3);font-variant-numeric:tabular-nums;font-weight:700;font-size:11px;font-family:var(--brand-font)';

    // v79.6: per-day note state — show a 📝 if note exists, click date to toggle editor.
    // v79.10: button-styled pill so it's discoverable. Clicking anywhere
    // on the date cell still toggles the editor (large hit target on mobile).
    var note = _kpiNotes[r.date] || null;
    var isEditingNote = _kpiNoteEditingDate === r.date;
    var noteIndicator = note
      ? ' <span style="display:inline-block;font-size:10px;background:var(--ok-bg);color:var(--ok);padding:2px 6px;border-radius:4px;font-weight:600;margin-inline-start:6px;vertical-align:middle">\uD83D\uDCDD Note</span>'
      : ' <span style="display:inline-block;font-size:10px;background:var(--card);color:var(--sub);border:1px dashed var(--border-strong);padding:1px 6px;border-radius:4px;font-weight:500;margin-inline-start:6px;vertical-align:middle">+ Note</span>';

    html += '<tr style="' + rowBg + '">' +
      '<td style="padding:8px 10px;border-bottom:1px solid var(--surface-3)">' +
        '<div style="font-weight:' + (isToday ? '700' : '500') + '">' + escapeHtml(dateLabel) + '</div>' +
      '</td>' +
      '<td style="text-align:end;padding:8px 6px;border-bottom:1px solid var(--surface-3);font-variant-numeric:tabular-nums;font-weight:' + (r.sales != null ? '600' : '400') + '">' + salesCell + '</td>' +
      '<td style="text-align:end;padding:8px 6px;border-bottom:1px solid var(--surface-3);font-variant-numeric:tabular-nums;color:var(--sub)">' + lyValueCell + '</td>' +
      '<td style="text-align:end;padding:8px 6px;border-bottom:1px solid var(--surface-3);font-variant-numeric:tabular-nums;color:' + lyColor + ';font-weight:600">' + lyCell + '</td>' +
      '<td style="text-align:end;padding:8px 6px;border-bottom:1px solid var(--surface-3);font-variant-numeric:tabular-nums;color:var(--sub)">' + targetCell + '</td>' +
      '<td style="text-align:end;padding:8px 6px;border-bottom:1px solid var(--surface-3);font-variant-numeric:tabular-nums;color:' + vsTargetColor + ';font-weight:600">' + vsTargetCell + '</td>' +
      '<td style="' + addonStyle + ';color:' + demo.color + '">' + demo.text + '</td>' +
      '<td style="' + addonStyle + ';color:' + bat.color  + '">' + bat.text  + '</td>' +
      '<td style="' + addonStyle + ';color:' + wrap.color + '">' + wrap.text + '</td>' +
      '<td style="' + addonStyle + ';color:' + bag.color  + '">' + bag.text  + '</td>' +
      '<td style="' + addonStyle + ';color:' + card.color + '">' + card.text + '</td>' +
      '<td title="Click to ' + (note ? 'edit' : 'add') + ' a note for this day" style="text-align:center;padding:8px 8px;border-bottom:1px solid var(--surface-3);cursor:pointer" onclick="toggleKpiNoteEditor(\'' + r.date + '\')">' + noteIndicator + '</td>' +
      '</tr>';

    // Sub-row for the note (display or editor). Spans all 9 columns. Only
    // rendered when note exists OR user is actively editing this date.
    if (note && !isEditingNote) {
      html += '<tr><td colspan="12" style="padding:6px 12px 10px;background:' + (isToday ? 'var(--stores-today-bg)' : 'var(--surface-2)') + ';border-bottom:1px solid var(--surface-3)">' +
        '<div style="display:flex;gap:8px;align-items:flex-start">' +
          '<div style="flex:0 0 auto;font-size:11px;color:var(--sub);font-weight:600;text-transform:uppercase;letter-spacing:.5px;padding-top:2px">Note</div>' +
          '<div translate="no" style="flex:1;font-size:12px;color:var(--text);line-height:1.4;white-space:pre-wrap;word-break:break-word">' + escapeHtml(note.note) + '</div>' +   // v135.1: typed by staff
          '<button onclick="toggleKpiNoteEditor(\'' + r.date + '\')" style="flex:0 0 auto;background:none;border:1px solid var(--border);color:var(--green);font-size:10px;padding:3px 8px;border-radius:4px;font-weight:600;cursor:pointer;font-family:inherit">Edit</button>' +
        '</div>' +
      '</td></tr>';
    } else if (isEditingNote) {
      var existingText = note ? note.note : '';
      html += '<tr><td colspan="12" style="padding:8px 12px 10px;background:var(--stores-ok-soft);border-bottom:1px solid var(--surface-3)">' +
        '<div style="display:flex;flex-direction:column;gap:6px">' +
          '<div style="font-size:11px;color:var(--sub);font-weight:600;text-transform:uppercase;letter-spacing:.5px">Note for ' + escapeHtml(formatKpiDate(r.date)) + '</div>' +
          '<textarea id="kpiNoteInput_' + r.date + '" maxlength="1000" placeholder="e.g. heavy rain, mall closed, school holiday…" style="border:1px solid var(--border);border-radius:6px;padding:6px 8px;font-size:13px;font-family:inherit;min-height:60px;resize:vertical">' + escapeHtml(existingText) + '</textarea>' +
          '<div style="display:flex;gap:6px;align-items:center;flex-wrap:wrap">' +
            '<button onclick="saveKpiNote(\'' + r.date + '\')" style="background:var(--green);color:#fff;border:none;border-radius:6px;padding:6px 14px;font-size:12px;font-weight:600;cursor:pointer;font-family:inherit">Save</button>' +
            '<button onclick="cancelKpiNote()" style="background:var(--card);color:var(--sub);border:1px solid var(--border);border-radius:6px;padding:6px 14px;font-size:12px;font-weight:600;cursor:pointer;font-family:inherit">Cancel</button>' +
            (note ? '<button onclick="deleteKpiNote(\'' + r.date + '\')" style="background:var(--card);color:var(--danger-deep);border:1px solid var(--stores-danger-line);border-radius:6px;padding:6px 14px;font-size:12px;font-weight:600;cursor:pointer;font-family:inherit;margin-inline-start:auto">Delete</button>' : '') +
          '</div>' +
        '</div>' +
      '</td></tr>';
    }
  });

  html += '</tbody></table></div>';
  html += addonsUpdatedLine(rows);   // v133.102
  content.innerHTML = html;
}
day.renderKpiDayView = renderKpiDayView;

// v133.102: Wafi City, 10 Oct 2026: "Checking for the updated KPI but the demo not updated ... should be 1pc".
// The demo was right: it arrived in the daily feed at 13:15, and they looked at 08:18. Saying when the
// add-on figures last arrived lets a store tell "not in yet" from "wrong". Pure, exported for the test.
export function addonsUpdatedLine(rows) {
  var latest = null;
  (Array.isArray(rows) ? rows : []).forEach(function (r) {
    var t = r && r.actual_updated_at ? new Date(r.actual_updated_at) : null;
    if (t && !isNaN(t.getTime()) && (!latest || t > latest)) latest = t;
  });
  if (!latest) return '';
  var when = latest.toLocaleString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
  return '<div style="font-size:11px;color:var(--sub);margin:8px 2px 0">Add-on figures (demos, batteries, gift wrap, bags, gift cards) arrive once a day. Last received: ' +
    escapeHtml(when) + '. A day not in yet shows –.</div>';
}

// ── compare ─────────────────────────────────────────────
export const compare = {};

async function renderKpiCompareView(){
  var content = document.getElementById('kpiContent');
  // Loading state — keep it simple, comparison query touches more data
  // than per-store /api/kpi so it can take a couple of seconds.
  content.innerHTML =
    '<div style="background:var(--card);border:1px solid var(--border);border-radius:12px;padding:30px 18px;text-align:center;margin-top:8px;max-width:980px;margin:8px auto 0">' +
    '<div style="font-size:13px;color:var(--sub)">Loading comparison\u2026</div>' +
    '</div>';

  var range = compareScopeRange(_kpiCompareScope);
  var data;
  // v81.5 — `_kpiCurrentStore` reflects the KPI screen's own store dropdown
  // (the picker you see at the top right of this screen for area managers).
  // `currentStore` is the Rota screen's state, which for an area manager
  // defaults to the first store on their list at login and stays there
  // until they explicitly visit the Rota tab. Using `currentStore` here
  // was making the Ranking tab highlight the wrong "your store" row —
  // e.g. KPI dropdown shows Mushrif Mall, ranking highlights Al Seef
  // Village. Fall back to currentStore in case _kpiCurrentStore hasn't
  // been initialised (defensive — renderKpiScreen always sets it before
  // any sub-tab can render, so this is belt-and-braces).
  var kpiStore = (typeof _kpiCurrentStore !== 'undefined' && _kpiCurrentStore) ? _kpiCurrentStore : currentStore;
  try {
    data = await DB.kpi.comparison({
      from: range.from, to: range.to, store: kpiStore,
    });
  } catch (e) {
    content.innerHTML =
      '<div style="background:var(--card);border:1px solid var(--border);border-radius:12px;padding:18px;margin:8px auto 0;max-width:980px;color:var(--red)">' +
      'Failed to load comparison: ' + escapeHtml(e.message || String(e)) +
      '</div>';
    return;
  }

  var rows  = data.rows || [];
  var avg   = data.company_avg || {};
  var pcts  = ['sales_pct','demo_pct','bat_pct','wrap_pct','bag_pct','cards_pct'];

  // v79.14: compute overall rank by sales_pct BEFORE applying user sort.
  // Rank is always by sales% — that's the headline KPI staff care about
  // and what an area manager would lead with in a 1:1.
  var ranked = rows.slice()
    .filter(function(r){ return r.sales_pct != null; })
    .sort(function(a, b){ return b.sales_pct - a.sales_pct; });
  var totalRanked = ranked.length;
  var myRankIdx = -1;
  for (var i = 0; i < ranked.length; i++) {
    if (ranked[i].store === kpiStore) { myRankIdx = i; break; }
  }
  var myRank = myRankIdx >= 0 ? myRankIdx + 1 : null;
  var myPct  = myRankIdx >= 0 ? ranked[myRankIdx].sales_pct : null;

  // Sort by current sortBy/Dir for the table display. Nulls sort last.
  rows.sort(function(a, b){
    var av = a[_kpiCompareSortBy], bv = b[_kpiCompareSortBy];
    if (av == null && bv == null) return 0;
    if (av == null) return 1;
    if (bv == null) return -1;
    return _kpiCompareSortDir === 'asc' ? av - bv : bv - av;
  });

  // ── HTML BUILD ────────────────────────────────────────
  var html = '';

  // v79.14: Rank banner — prominent, not buried in a cell. Color-coded
  // by tertile so a quick glance tells the user where they sit.
  // Top third = green, middle = amber, bottom = red. Rank null (current
  // store has no sales data yet) = neutral grey.
  if (myRank != null && totalRanked > 0) {
    var tertile = myRank <= Math.ceil(totalRanked / 3) ? 'top'
                : myRank >  Math.ceil(totalRanked * 2 / 3) ? 'bottom'
                : 'middle';
    var bannerColors = {
      top:    { bg: 'var(--ok-bg)', border: 'var(--ok-border)', text: 'var(--ok-deep)', icon: '\uD83C\uDFC6' },  // 🏆
      middle: { bg: 'var(--warn-bg)', border: 'var(--stores-warn-line)', text: 'var(--warn-deep)', icon: '\uD83D\uDCCA' },  // 📊
      bottom: { bg: 'var(--danger-bg)', border: 'var(--stores-danger-line)', text: 'var(--danger-deep)', icon: '\uD83D\uDCC9' },  // 📉
    };
    var c = bannerColors[tertile];
    var rankLabel = tertile === 'top' ? 'Top third'
                  : tertile === 'bottom' ? 'Bottom third'
                  : 'Middle third';
    html += '<div style="max-width:980px;margin:8px auto 0;padding:0 8px"><div style="background:' + c.bg + ';border:1px solid ' + c.border + ';border-radius:12px;padding:14px 16px;display:flex;align-items:center;gap:14px;flex-wrap:wrap">' +
      '<div style="font-size:32px;flex:0 0 auto">' + c.icon + '</div>' +
      '<div style="flex:1;min-width:180px">' +
        '<div style="font-size:18px;font-weight:700;color:' + c.text + '">You\u2019re ranked #' + myRank + ' of ' + totalRanked + '</div>' +
        '<div style="font-size:12px;color:' + c.text + ';opacity:0.85;margin-top:2px">' +
          rankLabel + ' for ' + escapeHtml(range.label) + ' \u2022 Sales: ' + myPct.toFixed(1) + '% of target' +
        '</div>' +
      '</div>' +
    '</div></div>';
  } else if (totalRanked > 0) {
    // Current store has no sales_pct (no data uploaded yet for this period).
    html += '<div style="max-width:980px;margin:8px auto 0;padding:0 8px"><div style="background:var(--surface-2);border:1px solid var(--border);border-radius:12px;padding:14px 16px;font-size:13px;color:var(--sub)">' +
      'Your store has no data yet for ' + escapeHtml(range.label) + '. Comparison shows ' + totalRanked + ' other stores.' +
    '</div></div>';
  }

  // Header strip: scope buttons + month picker
  html += '<div style="max-width:980px;margin:10px auto 0;padding:0 8px;display:flex;align-items:center;gap:8px;flex-wrap:wrap">';
  html += '<div style="font-size:11px;color:var(--sub);font-weight:600;text-transform:uppercase;letter-spacing:.5px;margin-inline-end:auto">📈 Comparison \u2014 ' + escapeHtml(range.label) + '</div>';

  // Quick scope buttons — covering the most-used cases
  var quickButtons = [
    { value: 'MTD',        label: 'MTD' },
    { value: 'last_month', label: 'Last month' },
    { value: 'YTD',        label: 'YTD' },
  ];
  quickButtons.forEach(function(btn){
    var active = btn.value === _kpiCompareScope;
    html += '<button onclick="setCompareScope(\'' + btn.value + '\')" style="padding:5px 10px;border:1px solid ' +
      (active ? 'var(--green)' : 'var(--border)') + ';background:' +
      (active ? 'var(--green)' : 'var(--card)') + ';color:' +
      (active ? '#fff' : 'var(--sub)') + ';border-radius:8px;font-size:11px;font-weight:600;cursor:pointer;font-family:inherit">' +
      escapeHtml(btn.label) + '</button>';
  });

  // Month dropdown — for picking any specific month
  var monthOpts = buildMonthOptions();
  // Is the current scope a specific month? If so, the dropdown should
  // reflect the active value.
  var monthSelected = /^\d{4}-\d{2}$/.test(_kpiCompareScope) ? _kpiCompareScope : '';
  html += '<select onchange="setCompareScope(this.value)" style="padding:5px 8px;border:1px solid ' +
    (monthSelected ? 'var(--green)' : 'var(--border)') + ';background:var(--card);color:' +
    (monthSelected ? 'var(--green)' : 'var(--sub)') +
    ';border-radius:8px;font-size:11px;font-weight:600;cursor:pointer;font-family:inherit">';
  html += '<option value="">' + (monthSelected ? '\u2014 month \u2014' : 'Or pick a month\u2026') + '</option>';
  monthOpts.forEach(function(o){
    var selected = o.value === monthSelected ? ' selected' : '';
    html += '<option value="' + o.value + '"' + selected + '>' + escapeHtml(o.label) + '</option>';
  });
  html += '</select>';
  html += '</div>';

  // Table
  html += '<div style="max-width:980px;margin:4px auto 0;background:var(--card);border:1px solid var(--border);border-radius:12px;position:relative">';
  html += '<table style="width:100%;min-width:780px;border-collapse:collapse;table-layout:auto;font-size:13px">';

  var thBase = 'background:var(--surface-2);border-bottom:1px solid var(--border);font-weight:700;position:sticky;top:var(--top-h,56px);z-index:20';
  var headers = [
    { key: 'rank',      label: 'Rank',      align: 'end',  noSort: true },
    { key: 'store',     label: 'Store',     align: 'start' },
    { key: 'sales_pct', label: 'Sales %',   align: 'end' },
    { key: 'demo_pct',  label: 'Demo %',    align: 'end' },
    { key: 'bat_pct',   label: 'Bat %',     align: 'end' },
    { key: 'wrap_pct',  label: 'Wrap %',    align: 'end' },
    { key: 'bag_pct',   label: 'Bag %',     align: 'end' },
    { key: 'cards_pct', label: 'Cards %',   align: 'end' },
  ];
  html += '<thead><tr>';
  headers.forEach(function(h){
    if (h.noSort) {
      html += '<th style="text-align:' + h.align + ';padding:10px;' + thBase + '">' + escapeHtml(h.label) + '</th>';
      return;
    }
    var isSorted = _kpiCompareSortBy === h.key;
    var arrow = isSorted ? (_kpiCompareSortDir === 'asc' ? ' \u25B2' : ' \u25BC') : '';
    html += '<th onclick="setCompareSort(\'' + h.key + '\')" style="text-align:' + h.align + ';padding:10px;cursor:pointer;' + thBase + '">' +
      escapeHtml(h.label) + arrow + '</th>';
  });
  html += '</tr></thead>';

  // Build a rank lookup so we can show the rank in each row
  var rankByStore = {};
  ranked.forEach(function(r, idx){ rankByStore[r.store] = idx + 1; });

  // Company avg row (sticky-ish, but actually just at the top of tbody)
  html += '<tbody>';
  html += '<tr style="background:var(--info-bg);border-bottom:2px solid var(--border)">' +
    '<td style="padding:8px 10px;font-weight:700;color:var(--sub);font-size:11px;text-align:end">\u2014</td>' +
    '<td style="padding:8px 10px;font-weight:700">🏢 Company avg</td>';
  pcts.forEach(function(p){
    var v = avg[p];
    html += '<td style="text-align:end;padding:8px 10px;font-weight:700;font-variant-numeric:tabular-nums">' +
      (v != null ? v.toFixed(1) + '%' : '—') + '</td>';
  });
  html += '</tr>';

  // Per-store rows
  rows.forEach(function(r){
    var isCurrent = r.store === currentStore;
    var rowBg = isCurrent ? 'background:var(--stores-today-bg)' : '';
    var rowRank = rankByStore[r.store];
    html += '<tr style="' + rowBg + ';border-bottom:1px solid var(--surface-3)">';
    html += '<td style="padding:8px 10px;text-align:end;font-variant-numeric:tabular-nums;color:var(--sub);font-size:12px">' +
      (rowRank != null ? '#' + rowRank : '\u2014') + '</td>';
    html += '<td style="padding:8px 10px;' + (isCurrent ? 'font-weight:700' : '') + '">' +
      escapeHtml(r.store) +
      (r.country ? ' <span style="color:var(--sub);font-size:11px">(' + escapeHtml(r.country) + ')</span>' : '') +
      (isCurrent ? ' <span style="color:var(--rota-green-ink);font-size:11px;font-weight:600">(your store)</span>' : '') +
      '</td>';
    pcts.forEach(function(p){
      var v = r[p];
      var avgV = avg[p];
      // Below company avg = red. Strict inequality so equal values aren't flagged.
      var isBelow = v != null && avgV != null && v < avgV;
      var color = isBelow ? 'var(--red)' : '';
      var weight = isBelow ? 'font-weight:600' : '';
      html += '<td style="text-align:end;padding:8px 10px;font-variant-numeric:tabular-nums;color:' + color + ';' + weight + '">' +
        (v != null ? v.toFixed(1) + '%' : '—') + '</td>';
    });
    html += '</tr>';
  });
  html += '</tbody></table></div>';

  // Help text
  html += '<div style="max-width:980px;margin:8px auto 0;padding:0 8px;font-size:11px;color:var(--sub)">' +
    'Rank is by Sales %. Cells in <span style="color:var(--red);font-weight:600">red</span> are below company average. ' +
    'Click a column header to sort. Range: ' + escapeHtml(range.from) + ' to ' + escapeHtml(range.to) + '.' +
    '</div>';

  // ─── v80.5 — Top 50 store ranking section ───
  // Adds a second ranking below the main Sales% table, using the latest
  // Top 50 weekly report. Stores are ranked by total units sold across
  // the top 50 volume products. This is a separate ranking from the
  // sales-target one above — Top 50 measures sell-through on the
  // commercially-managed top sellers regardless of overall store target.
  // Mount point gets filled in async after the main HTML is committed.
  html += '<div id="kpiTop50RankSection" style="max-width:980px;margin:18px auto 0;padding:0 8px"></div>';

  content.innerHTML = html;

  // Fire the Top 50 rank load AFTER innerHTML is set so the section's
  // mount point exists. Best-effort — failure is non-fatal, the main
  // sales-rank table stays visible.
  Top50.staff.loadStoreRank();
}
compare.renderKpiCompareView = renderKpiCompareView;

// ── demo ─────────────────────────────────────────────
export const demo = {};

function renderDemoLineCard(rows){
  var card = document.getElementById('demoLineCurrent');
  if (!card) return;
  var todayStr = localDateStr(new Date());
  var todayWeek = isoWeekFromDateStr(todayStr);
  var todayWeekKey = todayWeek.year + '-' + String(todayWeek.week).padStart(2, '0');

  // Find a row from this week — any row in this ISO week shares the
  // same demo_line_name/price (set per week, not per day).
  var thisWeekRow = null;
  (rows || []).forEach(function(r){
    if (!r.date) return;
    var w = isoWeekFromDateStr(r.date);
    var k = w.year + '-' + String(w.week).padStart(2, '0');
    if (k === todayWeekKey && r.demo_line_name) thisWeekRow = r;
  });

  var label = 'Week ' + todayWeek.week + ' (' + todayWeek.year + ')';
  if (!thisWeekRow) {
    card.innerHTML = '<strong>' + label + ':</strong> ' +
      '<span style="color:var(--red);font-weight:500">Not set</span> ' +
      '<span style="color:var(--sub)">— set this week\'s demo to see Demo targets</span>';
    return;
  }
  // v79.9: scope indicator. The hierarchy is store > country > company,
  // so a row with scope='country' or 'company' means the store hasn't
  // overridden it. We show this so staff understand WHERE the demo came
  // from and that they CAN override it by editing.
  var scope = thisWeekRow.demo_line_scope || 'store';
  var scopeLabel = '';
  if (scope === 'country') {
    scopeLabel = ' <span style="color:var(--sub);font-size:12px">— set at country level (you can override)</span>';
  } else if (scope === 'company') {
    scopeLabel = ' <span style="color:var(--sub);font-size:12px">— set at company level (you can override)</span>';
  }
  card.innerHTML = '<strong>' + label + ':</strong> ' +
    '<strong translate="no">' + escapeHtml(thisWeekRow.demo_line_name) + '</strong>' +   // v135.1: the item name staff typed
    ' <span style="color:var(--sub)">@</span> ' +
    '<strong style="font-variant-numeric:tabular-nums">' +
      Number(thisWeekRow.demo_line_price).toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2}) +
    '</strong>' + scopeLabel;
}
demo.renderDemoLineCard = renderDemoLineCard;

function openDemoLineEdit(){
  var todayStr = localDateStr(new Date());
  var todayWeek = isoWeekFromDateStr(todayStr);
  var todayWeekKey = todayWeek.year + '-' + String(todayWeek.week).padStart(2, '0');

  // Pre-fill from this week's entry, if any
  var current = null;
  (_kpiData || []).forEach(function(r){
    if (!r.date) return;
    var w = isoWeekFromDateStr(r.date);
    var k = w.year + '-' + String(w.week).padStart(2, '0');
    if (k === todayWeekKey && r.demo_line_name && !current) current = r;
  });
  document.getElementById('demoLineItemInput').value  = current ? (current.demo_line_name || '') : '';
  document.getElementById('demoLinePriceInput').value = current ? (current.demo_line_price || '') : '';
  document.getElementById('demoLineEditor').style.display = 'block';
  document.getElementById('demoLineEditStatus').textContent = 'Editing Week ' + todayWeek.week + ' (' + todayWeek.year + ')';
  document.getElementById('demoLineEditStatus').style.color = 'var(--sub)';
  setTimeout(function(){ document.getElementById('demoLineItemInput').focus(); }, 50);
}
demo.openDemoLineEdit = openDemoLineEdit;

// ── window bindings ─────────────────────────────────
// v130.54 — this bundle is now LAZY (loaded on the first tap of the KPI tab),
// so these aliases can no longer live in index.html's DOMContentLoaded block:
// `Kpi` does not exist when that block runs, the whole group would throw, and
// the try/catch around it would swallow the error — leaving renderKpiScreen
// permanently undefined and the tab permanently blank. Exactly the shape that
// broke the defer work twice (see docs/field-lessons.md).
//
// Binding here instead means the aliases appear at the same moment the bundle
// does. chat, news and tasks already do it this way; kpi was the odd one out,
// which is the only reason it could not be made lazy earlier.
if (typeof window !== 'undefined') {
  window.renderKpiScreen        = screen.renderKpiScreen;
  window.renderKpiFilterBar     = screen.renderKpiFilterBar;
  window.switchKpiTab           = tabs.switchKpiTab;
  window.renderKpiTab           = tabs.renderKpiTab;
  window.renderKpiCards         = tabs.renderKpiCards;
  window.toggleKpiTargetMode    = controls.toggleKpiTargetMode;
  window.toggleKpiFuture        = controls.toggleKpiFuture;
  window.toggleKpiNoteEditor    = controls.toggleKpiNoteEditor;
  window.switchAggregateScope   = aggregate.switchAggregateScope;
  window.renderAggregateKpi     = aggregate.renderAggregateKpi;
  window.renderKpiAiSummaryCard = aggregate.renderKpiAiSummaryCard;
  window.renderKpiPeriodView    = period.renderKpiPeriodView;
  window.renderKpiWeekView      = period.renderKpiWeekView;
  window.renderKpiMonthView     = period.renderKpiMonthView;
  window.renderKpiPlaceholder   = period.renderKpiPlaceholder;
  window.renderKpiDayView       = day.renderKpiDayView;
  window.renderKpiCompareView   = compare.renderKpiCompareView;
  window.renderDemoLineCard     = demo.renderDemoLineCard;
  window.openDemoLineEdit       = demo.openDemoLineEdit;
}
